import React, { useEffect, useState } from "react";
import Breadcrump from "../../components/Breadcrump";
import wishlistAPI from "../../api/wishlistApi";
import Product from "../products/Card";

const Wishlist = () => {
  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchWishList(1);
  }, []);

  const fetchWishList = async (pageNum = 1) => {
    setLoading(true);

    try {
      const res = await wishlistAPI.listing({ page: pageNum });

      if (res.code === 200) {
        const { products, pagination } = res.data;

        const items = products;

        setProducts((prev) => (pageNum === 1 ? items : [...prev, ...items]));
        setTotalCount(pagination.totalCount);
        setHasMore(pageNum * 6 < totalCount);
      } else {
        setError("No Product found in wishlist.");
      }
    } catch (err) {
      setError("You have to log in to view your wishlist.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const onScroll = () => {
      if (
        !loading &&
        hasMore &&
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 200
      ) {
        setPage((p) => p + 1);
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [loading, hasMore]);

  useEffect(() => {
    if (page > 1) fetchWishList(page);
  }, [page]);

  return (
    <>
      <Breadcrump title="WishList" />

      <section className="s-contact flat-spacing-13 pb-5">
        <div className="container">
          {error && <p className="text-danger text-center">{error}</p>}

          {products && products.length > 0 ? (
            <>
              <div className="blog-count text-left mb-4">
                Showing <b>{products?.length}</b> of <b>{totalCount}</b>{" "}
                products
              </div>

              <div className="row g-3 mt-2">
                {products.map((product, index) => (
                  <div key={product._id || index} className="col-md-3 col-6">
                    <Product product={product} />
                  </div>
                ))}
              </div>
            </>
          ) : (
            <>
              {!error && (
                <p className="text-center">No product found in wishlist</p>
              )}
            </>
          )}

          <div className="row">
            {loading &&
              [...Array(3)].map((_, i) => (
                <div className="col-md-4" key={i}>
                  <div className="blog-item-v2 mb-3">
                    <div className="entry-image hover-img skeleton-box skeleton-image" />

                    <div className="entry-content">
                      <div className="info-box">
                        <ul className="meta-list">
                          <li className="item skeleton-box skeleton-meta" />
                          <li className="item skeleton-box skeleton-meta" />
                        </ul>
                        <div className="title skeleton-box skeleton-title" />
                        <div className="desc skeleton-box skeleton-desc" />
                      </div>
                      <div className="btn-readmore skeleton-box skeleton-btn" />
                    </div>
                  </div>
                </div>
              ))}
          </div>

          {!hasMore && !loading && products.length > 6 && (
            <p className="text-center mt-4">You've reached the end.</p>
          )}
        </div>
      </section>
    </>
  );
};

export default Wishlist;
